module.exports = __webpack_public_path__ + "static/img/1-6.23f7f868.png";